export function add(ctx) {
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  try {
    ctx.commit('add', queryParams);
    return true;
  } catch (e) {
    return e;
  }
}
export function remove(ctx) {
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  try {
    ctx.commit('remove', queryParams);
    return true;
  } catch (e) {
    return e;
  }
}
export function update(ctx) {
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  try {
    ctx.commit('update', queryParams);
    return true;
  } catch (e) {
    return e;
  }
}
export function addDelivery(ctx) {
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  try {
    ctx.commit('addDelivery', queryParams);
    return true;
  } catch (e) {
    return e;
  }
}
export function setLocalStorage(ctx) {
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  try {
    ctx.commit('localStorage', queryParams);
    return true;
  } catch (error) {
    return error;
  }
}
export function clean(ctx) {
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  try {
    ctx.commit('clean');
    return true;
  } catch (e) {
    return e;
  }
}